var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"value":_vm.convert(_vm.value),"placeholder":_vm.placeholder,"type":_vm.type,"format":_vm.format,"value-type":"format","name":_vm.name},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }